import {
  apiDeleteClinicalStudiesAssociationDiagnosesDiagnosisUuidVisitUuid,
  apiPostClinicalStudiesAssociationDiagnoses,
  apiPostDiagnoses,
  VisitAvailableDiagnoses,
} from "../../../api";
import { useSupportedDiagnoses } from "../../../catalogs/supported-diagnoses";
import { useSoftAssert } from "../../../utils/use-soft-assert";
import { DiagnosesTable } from "../diagnoses/diagnoses-table";
import { Patient } from "../patient";
import { BaseDataVisitField, Submittable } from "./base-data-visit-field";

export function DiagnosisDataVisitField(props: {
  prefill: VisitAvailableDiagnoses;
  patient: Patient;
  ref: (h: Submittable) => void;
  visitUuid: string;
}) {
  const supportedDiags = useSupportedDiagnoses();
  const variableInfo = supportedDiags.find(
    (d) => d.data_name === props.prefill.data_definition.data_name,
  );

  if (!useSoftAssert(variableInfo, "Diagnosis definition not found")) {
    return null;
  }

  return (
    <BaseDataVisitField
      associatedData={props.prefill.associated_data}
      existingData={props.prefill.existing_data}
      patient={props.patient}
      valueSelector={(d) => d.diagnosis_value}
      variableInfo={variableInfo}
      ref={props.ref}
      existingDataTable={(p) => (
        <DiagnosesTable
          api={props.patient.api}
          patient={props.patient}
          disableEdit
          disableHistory
          disablePagination
          canSelect="multi"
          {...p}
        />
      )}
      onSubmit={async ({ newValue, editedValue, addedUuids, removedUuids }) => {
        if (editedValue) {
          await props.patient.updateItem("diagnoses", editedValue.uuid, {
            diagnosis_value: editedValue.value,
          });
        }

        if (newValue != null) {
          await apiPostDiagnoses({
            body: {
              patient_id: props.patient.patientId,
              diagnosis_name: props.prefill.data_definition.data_name,
              diagnosis_value: newValue as any,
              study_visit_link: props.visitUuid,
            },
          });
        }

        if (addedUuids && addedUuids.length > 0) {
          await apiPostClinicalStudiesAssociationDiagnoses({
            body: {
              number_of_datapoints: addedUuids.length,
              associations: addedUuids.map((uuid) => ({
                diagnosis_uuid: uuid,
                study_visit_uuid: props.visitUuid,
              })),
            },
          });
        }

        for (const uuid of removedUuids ?? []) {
          await apiDeleteClinicalStudiesAssociationDiagnosesDiagnosisUuidVisitUuid(
            { path: { diagnosis_uuid: uuid, visit_uuid: props.visitUuid } },
          );
        }
      }}
    />
  );
}
